import React, { useState } from "react";
import asideMapping from "../../utility/aside";
import DataTable from 'react-data-table-component';
import LoaderIndex from "~/containers/LoaderIndex";
import TableFilters from "../elections/TableFilters";
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';

// import LoaderIndex from "../../containers/LoaderIndex"

const Volby2023Page = (props) => {
  const aside = (props.aside || []).map(asideMapping);
  const url = decodeURIComponent(props.to);
  const title = props.title;
  const graphData = props.dataGraph;
  const graphLegend = props.dataLegend;
  
  const parties = graphLegend?.parties ?? [];
  // "Premier: Measure to Boost Beginner Teachers Salaries on Its Way";

  const zratane = props.dataGraph['P_OKRSOK_PCT'] || 0;
  const zucastneni = props.dataGraph['P_ZUC'] || 0;
  const nezucastneni = (props.dataGraph['P_ZAP'] - props.dataGraph['P_ZUC']) || 0;
  const vsetci_volici = props.dataGraph['P_ZAP'] || 0;
  const ano = props.dataGraph['P_ANO'] || 0;
  const nie = props.dataGraph['P_NIE'] || 0;

  const [selectedFruit, setSelectedFruit] = useState('orange'); 

  const dataSummaryTable = [
    {
        region: 'Bratislavský kraj',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Trnavský kraj',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Trenčiansky kraj',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Nitriansky kraj',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Žilinský kraj',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Banskobystrický kraj',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Prešovský kraj',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Košický kraj',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Zahraničie',
        districts: 582,
        votersCount: 590921,
        involvedVotersCount: 431718,
        votersAttendance: 73.05,
        envelopesCount: 423503,
        envelopesCountPerc: 98.09,
        votesCount: 427111,
        votesCountPerc: 98.93,
    },
    {
        region: 'Spolu',
        districts: 5998,
        votersCount: 4432419,
        involvedVotersCount: 2916840,
        votersAttendance: 65.80,
        envelopesCount: 2865284,
        envelopesCountPerc: 98.23,
        votesCount: 48920,
        votesCountPerc: 98.78,
    },

];

  const columnsSummaryResultsTable = [
    {
        name: 'Kraj',
        selector: row => row.region,
        sortable: true,
    },
    {
        name: 'Počet okrskov',
        selector: row => row.districts,
        sortable: true,
    },
    {
        name: 'Počet zapísaných voličov',
        selector: row => row.votersCount,
        sortable: true,
    },
    {
        name: 'Počet zúčastnených voličov',
        selector: row => row.involvedVotersCount,
        sortable: true,
    },
    {
        name: 'Účasť voličov v %',
        selector: row => row.votersAttendance,
        sortable: true,
    },
    {
        name: 'Počet odovzdaných obálok osobne',
        selector: row => row.envelopesCount,
        sortable: true,
    },
    {
        name: 'Podiel odovzdaných obálok osobne v %',
        selector: row => row.envelopesCountPerc,
        sortable: true,
    },
    {
        name: 'Počet platných hlasov spolu',
        selector: row => row.votesCount,
        sortable: true,
    },
    {
        name: 'Podiel platných hlasov spolu v %:',
        selector: row => row.votesCountPerc,
        sortable: true,
    },
    ];

    const dataCountAndPercTable = [
        {
            partyId: 1,
            partyName: 'Slovenská ľudová strana Andreja Hlinku',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 3,
            partyName: 'DOBRÁ VOĽBA',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 4,
            partyName: 'Sloboda a Solidarita',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 5,
            partyName: 'SME RODINA',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 6,
            partyName: 'Slovenské Hnutie Obrody',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 7,
            partyName: 'ZA ĽUDÍ',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 8,
            partyName: 'MÁME TOHO DOSŤ !',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 9,
            partyName: 'Slovenská národná strana',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 10,
            partyName: 'Demokratická strana',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 11,
            partyName: 'OLANO',
            votesCount: 8191,
            votesPerc: 0.28,
        },
        {
            partyId: 12,
            partyName: 'PS',
            votesCount: 8191,
            votesPerc: 0.28,
        },
    ];

    

  const columnsTable01 = [
    {
        name: 'Číslo politického subjektu',
        selector: row => row.partyId,
        sortable: true,
    },
    {
        name: 'Názov politického subjektu',
        selector: row => row.partyName,
        sortable: true,
    },
    {
        name: 'Počet platných hlasov',
        selector: row => row.votesCount,
        sortable: true,
    },
    {
        name: 'Podiel platných hlasov v %',
        selector: row => row.votesPerc,
        sortable: true,
    },
    // {
    //     name: 'Počet voličov, ktorí využili právo prednostného hlasovania',
    //     selector: row => row.year,
    //     sortable: true,
    // },
    // {
    //     name: 'Podiel voličov, ktorí využili právo prednostného hlasovania v %',
    //     selector: row => row.year,
    //     sortable: true,
    // },
    // {
    //     name: 'Počet získaných mandátov',
    //     selector: row => row.year,
    //     sortable: true,
    // }
];
const dataCountAndPercTable02 = [
    {
        district: 'Bratislavský kraj',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Trnavský kraj',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Trenčiansky kraj',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Nitriansky kraj',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Žilinský kraj',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Banskobystrický kraj',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Prešovský kraj',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Košický kraj',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Zahraničie',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
    {
        district: 'Spolu',
        votesCount: 8191,
        party01: 368,
        party02: 12308,
        party03: 23445,
        party04: 1200,
        party05: 149230,
        party06: 123300,
        party07: 23001,
        party08: 2403,
    },
];

const columnsTable02 = [
    {
        name: 'Kraj',
        selector: row => row.district,
        sortable: true,
    },
    {
        name: 'Počet platných hlasov spolu',
        selector: row => row.votesCount,
        sortable: true,
    },
    {
        name: 'SMER SSD',
        selector: row => row.party01,
        sortable: true,
    },
    {
        name: 'HLAS SD',
        selector: row => row.party02,
        sortable: true,
    },
    {
        name: 'PS',
        selector: row => row.party03,
        sortable: true,
    },
    {
        name: 'SAS',
        selector: row => row.party04,
        sortable: true,
    },
    {
        name: 'OLANO',
        selector: row => row.party05,
        sortable: true,
    },
    {
        name: 'SME RODINA',
        selector: row => row.party06,
        sortable: true,
    },
    {
        name: 'KDH',
        selector: row => row.party07,
        sortable: true,
    },
    {
        name: 'Republika',
        selector: row => row.party08,
        sortable: true,
    },
    
];

const dataPriorityVotingTable = [
    {
        orderPriority: 1,
        orderOnPaper: 1,
        name: 'Richard',
        surname: 'Sulík',
        votesCount: 106333,
    },
    {
        orderPriority: 2,
        orderOnPaper: 2,
        name: 'Lucia',
        surname: 'Ďuriš Nicholsonová',
        votesCount: 64689,
    },
    {
        orderPriority: 3,
        orderOnPaper: 3,
        name: 'Martin',
        surname: 'Klus',
        votesCount: 29979,
    },
    {
        orderPriority: 4,
        orderOnPaper: 7,
        name: 'Jana',
        surname: 'Cigániková',
        votesCount: 28773,
    },
    {
        orderPriority: 5,
        orderOnPaper: 9,
        name: 'Branislav',
        surname: 'Gröhling',
        votesCount: 21322,
    },
];

const columnsTablePriorityVoting = [
    {
        name: 'Poradie po zohľadnení prednostného hlasovania',
        selector: row => row.orderPriority,
        sortable: true,
    },
    {
        name: 'Poradie na hlasovacom lístku',
        selector: row => row.orderOnPaper,
        sortable: true,
    },
    {
        name: 'Meno',
        selector: row => row.name,
        sortable: true,
    },
    {
        name: 'Priezvisko',
        selector: row => row.surname,
        sortable: true,
    },
    {
        name: 'Počet platných prednostných hlasov',
        selector: row => row.votesCount,
        sortable: true,
    },
    // {
    //     name: 'Podiel platných prednostných hlasov v %',
    //     selector: row => row.title,
    //     sortable: true,
    // },
    // {
    //     name: 'Kandidát',
    //     selector: row => row.title,
    //     sortable: true,
    // },
];


const dataTable = [
    {
        id: 1,
        title: 'Beetlejuice',
        director: 'Beetlejuice',
        year: '1988',
    },
    {
        id: 2,
        title: 'Ghostbusters',
        director: 'Ghostbusters',
        year: '1984',
    },
];

  const dataParties = [
    {
      "country": "SMER SSD",
      "Podiel hlasov": 27.2,
      "Podiel hlasovColor": "hsl(207, 90.86%, 65.69%)",
    },
    {
      "country": "Hlas SD",
      "Podiel hlasov": 19.8,
      "Podiel hlasovColor": "hsl(242.16, 46.06%, 52.75%)",
    },
    {
      "country": "PS",
      "Podiel hlasov": 13.2,
      "Podiel hlasovColor": "hsl(131.5, 65.22%, 63.92%)",
    },
    {
      "country": "OLANO",
      "Podiel hlasov": 4.1,
      "Podiel hlasovColor": "hsl(16.53, 81.46%, 59.8%)",
    },
    {
      "country": "Sme rodina",
      "Podiel hlasov": 2.3,
      "Podiel hlasovColor": "hsl(219.72, 33.33%, 58.24%)",
    },
    {
      "country": "SAS",
      "Podiel hlasov": 2.1,
      "Podiel hlasovColor": "hsl(280.15, 84.71%, 69.22%)",
    },
    {
      "country": "KDH",
      "Podiel hlasov": 1.6,
      "Podiel hlasovColor": "hsl(169.73, 62.01%, 64.9%)",
    }
  ];

  const data = [
    {
        "zratanost_hlasov": ' ',
        "Spočítané hlasy": zratane,
        "Spočítané hlasyColor": "hsl(213, 87%, 34%)",
        "Nespočítané hlasy": (100 - zratane),
        "Nespočítané hlasyColor": "#cfcfcf"
    },
  ];

  const dataPiePresence = [
    {
        "id": "Zúčastnilo sa",
        "label": "Zúčastnilo sa",
        "value": zucastneni,
        "color": "hsl(213, 87%, 34%)",
      },
      {
        "id": "Nezúčastnilo sa",
        "label": "Nezúčastnilo sa",
        "value": nezucastneni,
        "color": "#EE1C25"
      },
  ]

  const dataPieQuestion = [
    {
        "id": "Áno",
        "label": "Áno",
        "value": ano,
        "color": "hsl(213, 87%, 34%)",
      },
      {
        "id": "Nie",
        "label": "Nie",
        "value": nie,
        "color": "#EE1C25"
      },
  ]

  return (
    <div>
        <div className="container static-page elections">
            <h1>VOĽBY do národnej rady slovenskej republiky 2023</h1>            
            
            { props.dataGraph['P_ZUC'] === 0 && 
                <div className="chart-row">
                   <p>Čaká sa na zatvorenie volebných miestností a zverejnenie predbežných výsledkov ŠÚ SR</p>
                </div>
            }

            { props.dataGraph['P_ZUC'] !== 0 &&
            <div className="chart-row counted-graph-wrapper">
            <div className="chart-col full">
                <div className="chart-hdl">
                    Spracovaných <b>4 678</b> z celkového počtu <b>5 998</b> zápisníc | <b>87,20 %</b>
                </div>
                <div className="chart-box line thin">
                <ResponsiveBar
                    data={data}
                    keys={[
                        'Spočítané hlasy',
                        'Nespočítané hlasy'
                    ]}
                    colors={({id, data}) => data[`${id}Color`]}
                    indexBy="zratanost_hlasov"
                    margin={{ top: 0, right: 0, bottom: 20, left: 0 }}
                    padding={0.6}
                    minValue={0}
                    maxValue={100}
                    layout="horizontal"
                    valueScale={{ type: 'linear' }}
                    label={""}
                    valueFormat={function(e){return (e) + " %"}}
                    fill={[
                        {
                            match: {
                                id: 'fries'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'sandwich'
                            },
                            id: 'lines'
                        }
                    ]}
                    borderRadius={10}
                    borderColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'brighter',
                                1.6
                            ]
                        ]
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={null}
                    axisLeft={null}
                    enableGridY={false}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor="#FFFFFF"
                    role="application"
                    ariaLabel="Počet spočítaných zápisníc"
                    barAriaLabel={function(e){return e.id+": "+e.formattedValue+" in country: "+e.indexValue}}
                />
                </div>
            </div>

            </div>
            }

            <div className="elections-section">
                <h2>Priebežné neoficiálne výsledky za SR</h2>

                <div className="chart-box parties">
                <ResponsiveBar
                    data={dataParties}
                    keys={[
                        'Podiel hlasov',
                    ]}
                    colors={({id, data}) => data[`${id}Color`]}
                    indexBy="country"
                    margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                    padding={0.3}
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    // colors={{ scheme: 'nivo' }}
                    defs={[
                        {
                            id: 'dots',
                            type: 'patternDots',
                            background: 'inherit',
                            color: '#38bcb2',
                            size: 4,
                            padding: 1,
                            stagger: true
                        },
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: '#eed312',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ]}
                    fill={[
                        {
                            match: {
                                id: 'fries'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'sandwich'
                            },
                            id: 'lines'
                        }
                    ]}
                    borderColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                1.6
                            ]
                        ]
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                        // legend: 'country',
                        // legendPosition: 'middle',
                        // legendOffset: 32
                    }}
                    axisLeft={{
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                        // legend: 'food',
                        // legendPosition: 'middle',
                        // legendOffset: -40
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                2
                            ]
                        ]
                    }}
                    role="application"
                    ariaLabel="Podiel hlasov politickych stran"
                />
                </div>

                <div className="valued-stats-wrapper">
                    <div className="valued-stats-col border red text-right">
                        <div className="valued-stats-item">
                            <div className="val">65,80 %</div>
                            <div className="label">účasť</div>
                        </div>
                        <div className="valued-stats-item">
                            <div className="val">1,67 %</div>
                            <div className="label">voličov z cudziny</div>
                        </div>
                        <div className="valued-stats-item">
                            <div className="val">98,23 %</div>
                            <div className="label">voličov, ktorí odovzdali obálku podľa § 24 (osobne)</div>
                        </div>
                    </div>

                    <div className="valued-stats-col red">
                        <div className="valued-stats-item">
                            <div className="val">2 916 840</div>
                            <div className="label">zúčastnených</div>
                        </div>
                        <div className="valued-stats-item">
                            <div className="val">48 925</div>
                            <div className="label">voličov z cudziny</div>
                        </div>
                        <div className="valued-stats-item">
                            <div className="val">2 865 284</div>
                            <div className="label">voličov, ktorí odovzdali obálku podľa § 24 (osobne)</div>
                        </div>
                    </div>

                    <div className="valued-stats-col">
                        <div className="valued-stats-item">
                            <div className="val">4 432 419</div>
                            <div className="label">voličov zapísaných v zoznamoch voličov</div>
                        </div>
                        <div className="valued-stats-item">
                            <div className="val">2 881 511</div>
                            <div className="label">platných hlasov spolu</div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="elections-section">
                <h2>SÚHRNNÉ VÝSLEDKY HLASOVANIA PODĽA ÚZEMNÉHO ČLENENIA</h2>

                <TableFilters graphLegend={props.dataLegend} />
                <div className="data-table-wrapper">
                    <DataTable columns={columnsSummaryResultsTable} data={dataSummaryTable} pagination />
                </div>

            </div>

            <div className="elections-section">
                <h2>VÝSLEDKY PREDNOSTNÉHO HLASOVANIA POSTUPUJÚCICH POLITICKÝCH SUBJEKTOV</h2>
                
                <div className="text-center mb-20">
                    <select
                        onChange={e => setSelectedFruit(e.target.value)}
                    >                    
                        {parties.map((option) => {
                        return (                        
                            <option key={option.code} value={option.code}>
                            {option.name}
                            </option>
                        );
                        })}
                        <option selected disabled aria-readonly>Vyberte politický subjekt</option>
                    </select>
                </div>                

                <h3>Výsledky hlasovania za: <b>3 - Sloboda a Solidarita</b></h3>

                <div className="valued-stats-wrapper">
                    <div className="valued-stats-item">
                        <div className="val">179 246</div>
                        <div className="label">platných hlasov odovzdaných pre politický subjekt</div>
                    </div>
                    {/* <div className="valued-stats-item">
                        <div className="val">139 065</div>
                        <div className="label">voličov politického subjektu, ktorí využili právo prednostného hlasovania</div>
                    </div>
                    <div className="valued-stats-item">
                        <div className="val">77,58 %</div>
                        <div className="label">voličov, ktorí využili právo prednostného hlasovania z počtu platných hlasov</div>
                    </div> */}
                </div>

                <h2>ZMENENÉ PORADIE KANDIDÁTOV PO ZOHĽADNENÍ PREDNOSTNÉHO HLASOVANIA Všetci kandidáti</h2>
                
                <div className="data-table-wrapper">
                    <DataTable columns={columnsTablePriorityVoting} data={dataPriorityVotingTable} pagination />
                </div>
            </div>

            <div className="elections-section">
                <h2>POČET A PODIEL PLATNÝCH HLASOV ODOVZDANÝCH PRE POLITICKÉ SUBJEKTY PODĽA ÚZEMNÉHO ČLENENIA</h2>

                <TableFilters graphLegend={props.dataLegend} />
                <div className="data-table-wrapper">
                    <DataTable columns={columnsTable01} data={dataCountAndPercTable} pagination />
                </div>
            </div>

            <div className="elections-section">
                <h2>POČET A PODIEL PLATNÝCH HLASOV ODOVZDANÝCH PRE POLITICKÉ SUBJEKTY PODĽA ÚZEMNÉHO ČLENENIA</h2>

                <TableFilters graphLegend={props.dataLegend} />
                <div className="data-table-wrapper">
                    <DataTable columns={columnsTable02} data={dataCountAndPercTable02} pagination />
                </div>
            </div>

            
           
        </div>
        

      <LoaderIndex />
    </div>
  );
};

export default Volby2023Page;
